<template>
  <div class="animated fadeIn">
    <b-modal
      title="Choose period"
      class="modal-primary"
      v-model="modalDate"
      @ok="fetchData(), (modalDate = false)"
    >
      <b-form>
        <b-form-group label="From" label-for="date" :label-cols="3">
          <datepicker use-utc
                      format="yyyy-MM-dd"
                      :bootstrap-styling="true"
                      v-model="dateFrom"
                      name="dateFrom"
          ></datepicker>
        </b-form-group>
        <b-form-group label="To" label-for="dateTo" :label-cols="3">
          <datepicker use-utc
                      format="yyyy-MM-dd"
                      :bootstrap-styling="true"
                      v-model="dateTo"
                      name="dateTo"
          ></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-row>
      <b-col
        lg="12"
        style="margin-bottom:15px; border-bottom:2px solid black; padding-bottom:15px"
      >
        <span>Choose Data: </span>
        <b-form-select
          v-model="link"
          :options="options"
          style="width:200px; color: white; background: #343b41;"
          value-field="item"
          @change="(loading = true), fetchData()"
          text-field="name"
        ></b-form-select>

        <b-button
          @click="modalDate = true"
          class
          style="height: 26px; width: 26px; float:right"
          variant="transparent p-0"
        >
          <i class="icon-calendar" style="color: #20a8d8;"></i>
        </b-button>

        <span
          style="float:right; line-height:30px; margin-right:20px; color:rgb(32, 168, 216)"
        >
          {{ from ? from : dateFrom }} <b>|</b> {{ to ? to : dateTo }}
        </span>
      </b-col>

      <b-col lg="12">
        <b-card-header
          v-if="!loading"
          style="border-bottom:0px !important; font-size:1.5em"
        >
          <span style="padding:5px;">Total Records:</span>
          <b style="border-right:1px solid white; padding-right:5px;">{{
              total
            }}</b>
          <span style="padding:5px;">Total Price:</span>
          <b
          >${{
              totalPrice
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
            }}</b
          >
          <b-button
            class="download-button"
            variant="primary"
            size="xl"
            @click="downloadExcel()"
          >
            <div
              style="display:inline-block;"
              v-if="loading2019"
              class="loading"
            >
              <b-row>
                <b-col lg="12">
                  <div class="sk-double-bounce bouncing2">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>Download
          </b-button>
          <b-form-group
            style="display:inline-block; float:right; margin-bottom:15px"
          >
            <b-input-group size="xl">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-card-header>
        <div v-if="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>

        <b-table
          v-else
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          @filtered="onFiltered"
          :filter="filter"
          responsive="sm"
          :items="data"
          :fields="fields"
          style="background:#343b41; border:0px 1px solid black;"
        >
          <template v-slot:cell(fnsid)="data">
            <a
              v-bind:href="
                $trackerBase +
                  '/tracker_private/includes/customerHarReportPublic.php?ftrack=' +
                  data.item.fnsid
              "
            >{{ data.item.fnsid }}</a
            >
          </template>
          <template v-slot:cell(har)="data">
            <b-input
              style="display:inline-block; width:69%; height:30px"
              type="text"
              :ref="data.item.fnsid"
              v-model="data.item.har"
            />
            <b-button
              @click="updateHar(data.item.fnsid, data.item.har)"
              style="display:inline-block; width:30%; height:30px; margin-top: -5px;"
              size="sm"
            >Update</b-button
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import cTable from "./Table.vue";
import Datepicker from "vuejs-datepicker";

export default {
  name: "tables",
  components: { cTable, Datepicker },
  data: () => {
    return {
      excelDownload: "",
      loading2019: false,
      options: [
        { name: "Shipped To Customer", item: "delivered" },
        { name: "Active Backlog", item: "backlog" },
        { name: "Beyond Economical Repair", item: "ber" },
        { name: "End of life", item: "eol" }
      ],
      loadingExcel: false,
      productGroupParam: "",
      modelParam: "",
      link: "delivered",
      filter: null,
      dateFrom: "",
      dateTo: "",
      modalDate: false,
      newharid: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        { key: "pMode", label: "Model" },
        { key: "pMake", label: "Manufacturer" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true },
        // {key: 'rdays', label: 'Days', sortable: true},
        { key: "price", label: "Price", sortable: true }
      ]
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        xml: "true",
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/atx/tables/alldata-" + this.link + ".php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    fetchData() {
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/atx/tables/alldata-" + this.link + ".php", { params })
        .then(
          res => {
            if (res.data.message) {
              this.loading = false;
            }
            this.data = res.data.records;
            this.total = res.data.message ? 0 : res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            this.loading = false;
            console.log(err);
          }
        );
    },
    updateHar(fnsid, har) {
      this.loading = true;
      let formData = new FormData();
      formData.append("fnsid", fnsid);
      formData.append("harid", har);
      this.$http
        .post("api/atx/tables/updateHar.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(
          res => {
            console.log(res.data);
            this.fetchData();
          },
          err => {
            this.newharid = "";
            console.log(err);
          }
        );
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  mounted() {
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  display: inline-block;
  float: right;
  font-weight: 500;
  margin-left: 10px;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
.gm-style .gm-style-iw-d {
  color: black !important;
}
.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}
.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
</style>
